import { Usuario } from './../../../seguranca/usuario/usuario/usuario.model';
import { DefaultModel } from 'src/app/core/framework/default.model';
import { ICoordenada } from '../endereco/endereco.interface';

export enum PoiType {
  PONTO_INICIO_PROFISSIONAL = 'PONTO_INICIO_PROFISSIONAL',
  LOCAL_ATENDIMENTO = 'LOCAL_ATENDIMENTO'
}

export class Poi extends DefaultModel {
  tipo: PoiType;
  nome: string;
  descricao: string;
  idUsuarioResponsavel: number;
  usuarioResponsavel: Usuario;
  geom: {
    coordinates: ICoordenada
  };
}
